<div class="dropdown d-inline-block" dropdown (isOpenChange)="onOpenChange($event)"
  *ngIf="feed.available$ | async">

  <button type="button" class="btn header-item noti-icon" id="page-header-notifications-dropdown" dropdownToggle>
    <i class="bx bx-bell" [class.bx-tada]="(feed.unseenCount$ | async) > 0"></i>
    <span *ngIf="(feed.unseenCount$ | async) as unseenCount" class="badge bg-danger rounded-pill">
      {{ unseenCount }}
    </span>
  </button>

  <div class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
    aria-labelledby="page-header-notifications-dropdown" *dropdownMenu>

    <div class="p-3 border-bottom">
      <h6 class="m-0">Notifications</h6>
    </div>

    <ng-container *ngIf="(feed.recent$ | async) as notifications">
      <ng-container *ngIf="notifications.length; else noData">
        <ngx-simplebar style="position: relative; max-height: 260px;">
          <!-- No contact names in notification content by design: the bell is visible over a
               shoulder on any page. Who it concerns waits behind the permission-gated link. -->
          <a class="text-reset notification-item d-block" *ngFor="let notification of notifications"
            [routerLink]="notification.taskLink || '/notifications'">
            <div class="d-flex" [class.opacity-50]="notification.isViewed">
              <!-- flex-shrink-0: the icon is a flex item and long two-line messages
                   otherwise squeeze the circle into an oval. -->
              <div class="avatar-xs me-3 flex-shrink-0">
                <span class="avatar-title bg-danger rounded-circle font-size-16">
                  <i class="bx bxs-bell-ring"></i>
                </span>
              </div>
              <div class="flex-grow-1">
                <h6 class="mb-1 font-size-13">{{ notification.messageContent }}</h6>
                <div class="font-size-12 text-muted">
                  <p class="mb-0">
                    <i class="mdi mdi-clock-outline"></i>
                    {{ notification.createdDate | date:'dd/MM/yyyy HH:mm' }}
                  </p>
                </div>
              </div>
            </div>
          </a>
        </ngx-simplebar>
      </ng-container>

      <ng-template #noData>
        <div class="p-3">
          <p class="mb-0 font-size-12 text-muted">No notifications.</p>
        </div>
      </ng-template>
    </ng-container>

    <div class="p-2 border-top d-grid">
      <a class="btn btn-sm btn-link font-size-14 text-center" routerLink="/notifications">
        <i class="mdi mdi-arrow-right-circle me-1"></i>
        <span>View history</span>
      </a>
    </div>

  </div>
</div>
